import { isEmpty } from 'lodash';

import { CIReader } from './CIReader';
import type { Application } from '../application';
import { ApplicationDataSourceRegistry, navigationCategoryRegistry } from '../application';
import { SETTINGS } from '../config/settings';
import type { ICiBuild } from './domain';

export function registerCiDataSources(): void {
  if (!SETTINGS.feature.ci) {
    return;
  }

  const loadBuilds = (application: Application) => {
    const { repoType, repoProjectKey, repoSlug } = application.attributes;
    if (isEmpty(repoProjectKey) || isEmpty(repoType) || isEmpty(repoSlug)) {
      return Promise.resolve([]);
    }
    return CIReader.getBuilds(repoType, repoProjectKey, repoSlug);
  };

  const loadRunningBuilds = (application: Application) => {
    const { repoType, repoProjectKey, repoSlug } = application.attributes;
    if (isEmpty(repoProjectKey) || isEmpty(repoType) || isEmpty(repoSlug)) {
      return Promise.resolve([]);
    }
    return CIReader.getRunningBuilds(repoType, repoProjectKey, repoSlug);
  };

  if (!navigationCategoryRegistry.has('integration')) {
    navigationCategoryRegistry.register({
      key: 'integration',
      label: 'Integration',
      icon: 'icon-ci-branch',
      iconName: 'spCIBranch',
      primary: true,
      order: 0,
    });
  }

  ApplicationDataSourceRegistry.registerDataSource({
    key: 'integration',
    badge: 'runningBuilds',
    icon: 'icon-ci-branch',
    iconName: 'spCIBranch',
    category: 'integration',
    label: 'Integration',
    optional: true,
    lazy: true,
    description: 'Visibility into builds for pull requests and branches',
    requireConfiguredApp: true,
    defaultData: [],
  });

  ApplicationDataSourceRegistry.registerDataSource({
    key: 'builds',
    sref: '.builds',
    badge: 'runningBuilds',
    icon: 'icon-ci-build',
    iconName: 'spCIBuild',
    category: 'integration',
    label: 'Builds',
    lazy: true,
    requireConfiguredApp: true,
    requiresDataSource: 'integration',
    loader: loadBuilds,
    onLoad: (_: Application, data: ICiBuild) => Promise.resolve(data),
    defaultData: [],
  });

  ApplicationDataSourceRegistry.registerDataSource({
    key: 'runningBuilds',
    visible: false,
    description: 'running builds',
    loader: loadRunningBuilds,
    onLoad: (_: Application, data: ICiBuild) => Promise.resolve(data),
    defaultData: [],
  });
}

registerCiDataSources();
